// extracted by mini-css-extract-plugin
module.exports = {"table":"style_table__2IbIT","tableSub":"style_tableSub__2vZ4C"};